// extracted by mini-css-extract-plugin
export default {"root":"hpPGAWL31C"};